import { useContext } from "react";

import { KnowledgeBaseContext } from "../knowledge-base-provider";
import { KnowledgeBaseContextType } from "../types";

export const useKnowledgeBaseContext = (): KnowledgeBaseContextType => {
  const context = useContext(KnowledgeBaseContext);

  if (context === undefined) {
    throw new Error(
      "useKnowledgeBaseContext must be used inside KnowledgeBaseProvider"
    );
  }

  return context;
};
